const data = {
  primary: '#e71132',
  secondary: '#777576',
  black: '#3c3935',
  grey: '#eeeeee'
};

export default data;
